import Component from "./Component";
import Polygon from "./Polygon";
import Vector from "./Vector";

export default class Area extends Component {
    constructor({ coordinates, style, trigger, element }) {
        super({
            polygons: coordinates.map((_points) => {
                let depth = 2;
                if(_points[0][0]?.[0]) depth = 3;
                const points = depth === 3 ? _points[0] : _points;

                return new Polygon({
                    points: points.map(([ x, y ]) => new Vector(x, y).scale(10)),
                    style
                });
            }),
            trigger, element
        });
    }

}